<template>
    <div class="main">
        <a-card :loading="loading" style="border-radius: 20px;" :bordered="false">
            <div class="actions">
                <h3 style="font-size:28px;line-height:45px"> Invoices </h3>
                <div>
                    <!-- <a-button style="border-raduis:6px; background: #fff;color:#0F3659" icon="plus" class="mr-4">
                        Add New Leads
                    </a-button> -->
                    <a-button :loading="loading" @click="exportExcell"
                        style="border-raduis:6px; background: #fff;color:#0F3659" icon="export">
                        Export
                    </a-button>
                </div>
            </div>
            <div style="display:flex;justify-content: flex-end;margin-bottom: 20px;margin-top:10px">
                <div class="d-flex justify-content-between mr-4">
                    <p class="pt-1 mr-2">Filter By Status: </p>
                    <a-select :value="filterValue" default-value="all" style="width: 190px" @change="onInvoiceChange">
                        <a-select-option value="all">
                            All
                        </a-select-option>
                        <a-select-option value="0">
                            Pending
                        </a-select-option>
                        <a-select-option value="1">
                            Partially Paid
                        </a-select-option>
                        <a-select-option value="2">
                            Paid
                        </a-select-option>
                        <a-select-option value="3">
                            Overdue
                        </a-select-option>
                        <a-select-option value="4">
                            Critically Overdue
                        </a-select-option>
                        <a-select-option value="5">
                            Cancelled
                        </a-select-option>
                    </a-select>
                </div>


            </div>

            <div>
                <all-invoices @invoiceStatus="invoiceStatus" @invoiceData="handlePagination"
                    :purchaseOrdersData="tableAllInvoices" :paginateData="paginateData"></all-invoices>
            </div>

        </a-card>
    </div>
</template>

<script>

import moment from 'moment';
// import _ from 'lodash';
import XLSX from "xlsx";
import {  mapActions } from 'vuex';

import { NotificationMixins } from '@/mixins/NotificationMixins'
import AllInvoices from "./tables/AllInvoices.vue"



// import PendingPurchaseOrders from '../orders/tables/PendingPurchaseOrders.vue'
// import ReceivingPurchaseOrders from '../orders/tables/ReceivingPurchaseOrders.vue'
// import CompletedPurchaseOrders from '../orders/tables/CompletedPurchaseOrders.vue'
// import CancelledPurchaseOrders from '../orders/tables/CancelledPurchaseOrders.vue'


const tablePurchaseOrders = [
    {
        id: 1,
        key: 1,
        numberOfItems: 10,
        cretaedBy: 'Divine Bawa',
        createdAt: '12-06-2020',
        statusLabel: 'Draft',
        action: {
            id: 1,
            key: 1,
            numberOfItems: 10,
            cretaedBy: 'Divine Bawa',
            createdAt: '12-06-2020',
            statusLabel: 'Draft'
        }
    },
    {
        id: 2,
        key: 2,
        numberOfItems: 34,
        cretaedBy: 'Divine Bawa',
        createdAt: '12-06-2020',
        statusLabel: 'Draft',
        action: {
            id: 2,
            key: 2,
            numberOfItems: 34,
            cretaedBy: 'Divine Bawa',
            createdAt: '12-06-2020',
            statusLabel: 'Draft'
        }
    },
    {
        id: 3,
        key: 3,
        numberOfItems: 24,
        cretaedBy: 'Peter Bawa',
        createdAt: '12-06-2020',
        statusLabel: 'Pending',
        action: {
            id: 3,
            key: 3,
            numberOfItems: 24,
            cretaedBy: 'Peter Bawa',
            createdAt: '12-06-2020',
            statusLabel: 'Pending'
        }
    },
    {
        id: 4,
        key: 4,
        numberOfItems: 45,
        cretaedBy: 'Peter Bawa',
        createdAt: '12-06-2020',
        statusLabel: 'Completed',
        action: {
            id: 4,
            key: 4,
            numberOfItems: 45,
            cretaedBy: 'Peter Bawa',
            createdAt: '12-06-2020',
            statusLabel: 'Completed'
        }
    },
    {
        id: 5,
        key: 5,
        numberOfItems: 45,
        cretaedBy: 'Peter Bawa',
        createdAt: '12-06-2020',
        statusLabel: 'Cancelled',
        action: {
            id: 5,
            key: 5,
            numberOfItems: 45,
            cretaedBy: 'Peter Bawa',
            createdAt: '12-06-2020',
            statusLabel: 'Cancelled'
        }
    },
    {
        id: 6,
        key: 6,
        numberOfItems: 45,
        cretaedBy: 'Peter Bawa',
        createdAt: '12-06-2020',
        statusLabel: 'Receiving',
        action: {
            id: 6,
            key: 6,
            numberOfItems: 45,
            cretaedBy: 'Peter Bawa',
            createdAt: '12-06-2020',
            statusLabel: 'Receiving'
        }
    },
    
]

    export default {
        name: "PurchaseOrderHistory",
        components:{
            AllInvoices
        },
        data(){
            return{
                tableAllInvoices: [],
                tablePendingInvoices: [],
                tablePendingPurchaseOrders: [],
                tablePartiallyPaidInvoice: [],
                tablePaidInvoices:[],
                tableOverdueInvoice: [],
                tableCriticalOverdue:[],
                tableCancelledInvoice:[],
                availableInvoices: [],
                tablePurchaseOrders,
                loading: false,
                params:{
                    page: 1,
                    perPage: 10,
                    searchBy: {},
                    sortBy: {}
                },
                paginateData: {},
                filterValue: 'all'
            }
        },
        mixins: [ NotificationMixins ],
        methods:{
            ...mapActions(['addStockToWarehouse',]),
            redirectPreviousUrl(){
                this.$router.back()
            },  
            async exportExcell(){
                // console.log("tableAllOrdersData | ", this.tableAllOrdersData)
                this.loading = true;
                const dataToExport = [
                    [
                        "Invoice ID",
                        "Customer Name",
                        "Amount",
                        "Created At",
                        "Status",
                    ],
                ];
                

                let searchBy = this.filterValue === 'all' ? {} : { status: parseInt(this.filterValue)}

                this.params = {
                    ...this.params,
                    page: -1,
                    perPage: -1,
                    searchBy: searchBy
                }
                const response = await this.$store.dispatch('invoices/getInvoices', this.params);

                this.loading = false;

                if(response.status === 200){
                    response.data.data.forEach((v) => {
                            dataToExport.push([
                                v.id,
                                v.customerName,
                                v.totalOrderValue ? v.totalOrderValue.toLocaleString(undefined,{minimumFractionDigits: 2}) : '0.00',
                                v.createdAt,
                                v.statusLabel
                            ]);
                    });

                    var wb = XLSX.utils.book_new();
                    var ws = XLSX.utils.aoa_to_sheet(dataToExport);

                    /* Add the worksheet to the workbook */
                    XLSX.utils.book_append_sheet(wb, ws, "Sheet 1");

                    /* generate file and send to client */
                    XLSX.writeFile(wb, `Sales-Invoice-${moment().format('DD-MM-YYYY')}.xlsx`);
                    this.showSuccessAlert("Data Successfully Exported")
                }
            },

            onInvoiceChange(value){
                if(value == "all"){
                    this.params = {
                        ...this.params,
                        searchBy: {},
                    }
                    this.filterValue = value
                }else{
                    this.params = {
                        ...this.params,
                        searchBy: {
                            status: parseInt(value)
                        },
                    }
                    this.filterValue = value
                }
                this.loadInvoices()
            },

            handlePagination(pagination){
                this.params = {
                    ...this.params,
                    page: pagination.current,
                    
                }
                this.loadInvoices();
            },

            getAllInvoicesData(response){
                if(response.status === 200){
                    this.tableAllInvoices = response.data.data.map(invoice => ({
                        key: invoice.id,
                        id: invoice.id,
                        createdAt: moment(invoice.createdAt).format("DD-MM-YYYY"),
                        dueDate: moment(invoice.dueDate).format("DD-MM-YYYY"),
                        totalOrderValue: invoice.totalOrderValue ? invoice.totalOrderValue.toLocaleString(undefined,{minimumFractionDigits: 2}) : '0.00',
                        customerName: invoice.customerName,
                        statusLabel: invoice.invoiceStatusTypeLabel,
                        action: invoice
                    }))
                    this.paginateData = {
                        totalRecords: response.data.totalRecords,
                        current: this.params.page
                    }
                }else{
                    // console.log("Error | ", response)
                }
            },

            async orderData(data){
                if (data) {
                    this.loadInvoices();
                }  
            },

            invoiceStatus(data){
                if(data){
                    this.loadInvoices();
                }
            },
            async orderStatus(request_body) {
                const response = await this.$store.dispatch("purchaseOrder/updatePurchaseOrderStatus",request_body, { root: true} )
                if (response.status === 200) {
                    this.showSuccessAlert('Purchase Order Updated Successfully');
                    this.loadInvoices()
                } else {
                    this.showErrorAlert('Something went wrong');
                }
            },

            async loadInvoices(){
                this.loading = true;   
                const response = await this.$store.dispatch('invoices/getInvoices', this.params);
                this.loading = false;
                this.getAllInvoicesData(response)
            }
        },
        created(){
            if(this.loadInvoices){
                this.loadInvoices()
            }
        } 
}
</script>

<style scoped>

.card-container {
  background: none;
  overflow: hidden;
  /* padding: 24px; */
}
.card-container > .ant-tabs-card > .ant-tabs-content {
  height: 120px;
  margin-top: -16px;
}

.card-container > .ant-tabs-card > .ant-tabs-content > .ant-tabs-tabpane {
  background: #fff;
  padding: 16px;

}

.card-container >>> .ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-tab-active {
    height: 40px;
    color: #98c14b;
    background: #e5efe7;
    border-color: #e5efe7;
    border-bottom: 1px solid #98c14b;
}
.card-container >>> .ant-tabs-tab {
    height: 40px;
    margin: 0;
    width: 217px;
    margin-right: 2px;
    padding: 0 16px;
    line-height: 38px;
    background: #fafafa;
    border: 1px solid #e8e8e8;

}
.card-container >>> .ant-tabs-tab:hover {
    color: #98c14b;
    /* background: #e5efe7; */
}

.modalStyle >>> .ant-modal-header {
    border-bottom: none;
}

.modalStyle >>> .ant-modal-footer {
    border-top: none;
}
.modalStyle{
    display: flex;
    justify-content: center;
}

.card-container >>> .ant-badge-count {
    z-index: auto;
    min-width: 20px;
    height: 20px;
    padding: 0 6px;
    color: #fff;
    font-weight: normal;
    font-size: 12px;
    line-height: 20px;
    white-space: nowrap;
    text-align: center;
    background: #98c14b;
    border-radius: 10px;
    box-shadow: 0 0 0 1px #fff;
}

 .spinner >>> .ant-spin-dot-item {
    background-color: #418a49;
}

.card-container > .ant-tabs-card > .ant-tabs-bar {
  border-color: #fff;
}

.card-container > .ant-tabs-card > .ant-tabs-bar .ant-tabs-tab {
  border-color: transparent;
  background: transparent;
}

.card-container > .ant-tabs-card > .ant-tabs-bar .ant-tabs-tab-active {
  border-color: #e5efe7;
  background: #e5efe7;
}
</style>